export default [
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "Paiements",
      layout: "dashboard",
    },
    path: "/payments",
    name: "payments",
    component: () => import("@/layouts/index/PaymentIndex.vue"),
    children: [
      // Paiements clients
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Liste des paiements des clients",
          layout: "dashboard",
        },
        path: "customers/index",
        name: "payments-customers-index",
        component: () => import("@/views/payments/Listing.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Créer un nouveau paiement client",
          layout: "dashboard",
        },
        path: "customers/create",
        name: "payments-customers-create",
        component: () => import("@/views/payments/Create.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Modifier le paiement client",
          layout: "dashboard",
        },
        path: "customers/:reference/edit",
        name: "payments-customers-edit",
        component: () => import("@/views/payments/Edit.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Détails du paiement client",
          layout: "dashboard",
        },
        path: "customers/:reference/details",
        name: "payments-customers-details",
        component: () => import("@/views/payments/Details.vue"),
      },

      // Paiements fournisseurs
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Liste des paiements des fournisseurs",
          layout: "dashboard",
        },
        path: "suppliers/index",
        name: "payments-suppliers-index",
        component: () => import("@/views/payments/suppliers/Listing.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Créer un nouveau paiement fournisseur",
          layout: "dashboard",
        },
        path: "suppliers/create",
        name: "payments-suppliers-create",
        component: () => import("@/views/payments/suppliers/Create.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Modifier le paiement fournisseur",
          layout: "dashboard",
        },
        path: "suppliers/:reference/edit",
        name: "payments-suppliers-edit",
        component: () => import("@/views/payments/suppliers/Edit.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Détails du paiement fournisseur",
          layout: "dashboard",
        },
        path: "suppliers/:reference/details",
        name: "payments-suppliers-details",
        component: () => import("@/views/payments/suppliers/Details.vue"),
      },
    ],
  },
];
